import React from 'react';
import { Dialog, DialogContent } from '@/components/ui/SossietyDialog';
import { Button } from '@/components/ui/button';
import { SossietyDialogHeader, SossietyDialogClose } from '@/components/ui/SossietyDialogHeader';
import { useI18n } from '@/contexts/I18nContext';

interface DeleteClassModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  className?: string;
}

export const DeleteClassModal: React.FC<DeleteClassModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  className = ""
}) => {
  const { t } = useI18n();

  return (
          <Dialog open={isOpen} onOpenChange={onClose}>
        <DialogContent 
          className={`bg-white border-gray-300 rounded-2xl w-[90vw] max-w-md ${className}`}
          aria-describedby="delete-class-description"
        >
          <SossietyDialogHeader title={t('common.delete') + ' ' + t('calendar.class').toLowerCase()}>
            <SossietyDialogClose onClick={onClose} />
          </SossietyDialogHeader>

                  <div className="space-y-4">
            <p id="delete-class-description" className="text-gray-600 text-center">
              Are you sure you want to delete this class? This action cannot be undone.
            </p>

          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              disabled={isLoading}
              className="flex-1 border-black text-black hover:bg-gray-50 h-12 rounded-full"
            >
              Cancel
            </Button>
            <Button
              type="button"
              onClick={onConfirm}
              disabled={isLoading}
              className="flex-1 bg-red-600 hover:bg-red-700 text-white rounded-full h-12"
            >
              {isLoading ? 'Deleting...' : 'Delete Class'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
